<template>
  <div>
    <div class="">
      <ul class="list-group MobileHide pr-0 pl-0">
        <!-- <li class="list-group-item header" style="font-size: 13px;">
         <img :src="tournamentLogo + leagueId" style="width: 22px; margin-right: 5px;">
         {{tournmame}}
        <b-btn v-if="favsT.some(fav => fav.id == leagueId)" v-on:click="removeFavorite({value: leagueId , type: tournament})" style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/orStar.png" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: leagueId , type: tournament})" style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.svg" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn>           
         </li> -->

        <li
          style="background: #141416; list-style-type: none; height: 10px"
        ></li>

        <div
          class="container"
          style="background: #141416; margin-top: 0px"
          v-if="ryear != 0"
        >
          <div class="row">
            <b-form-select
              v-model="syear"
              @change="filter(syear)"
              class="mb-4 col mr-1"
              style="
                margin-top: 10px;
                background: #212225;
                border: none;
                border-radius: 2px;
                color: #e6e6e6;
              "
            >
              <b-form-select-option
                v-for="i in seasons"
                :key="i.id"
                :value="i.id"
                >{{
                  i.name | transliterate(cookiesObject.lang)
                }}</b-form-select-option
              >
            </b-form-select>
            <b-button
              style="
                background: #212225;
                border: none;
                height: 38px;
                margin-top: 10px;
              "
              class="col-1"
              @click="(day = parseInt(day) - 1), findDay()"
              ><img src="@/assets/left.png" style="width: 10px" alt=""
            /></b-button>
            <b-form-select
              v-model="ryear"
              @change="pull(ryear)"
              class="mb-4 col ml-1"
              style="
                margin-top: 10px;
                background: #212225;
                border: none;
                border-radius: 2px;
                color: #e6e6e6;
              "
            >
              <b-form-select-option
                v-for="i in rounds"
                :key="i.id"
                :value="i.id"
              >
                {{ "week" | transliterate(cookiesObject.lang) }}
                {{ i.name | transliterate(cookiesObject.lang) }} (
                <span v-if="i.start">{{
                  i.start.split("-")[2] | transliterate(cookiesObject.lang)
                }}</span>
                -
                <span v-if="i.end">{{
                  i.end.split("-")[2] | transliterate(cookiesObject.lang)
                }}</span>
                <span v-if="i.end">{{
                  monthNames[parseInt(i.end.split("-")[1] - 1)]
                    | transliterate(cookiesObject.lang)
                }}</span>
                )</b-form-select-option
              >
            </b-form-select>
            <b-button
              style="
                background: #212225;
                border: none;
                height: 38px;
                margin-top: 10px;
              "
              class="col-1 ml-1"
              @click="(day = parseInt(day) + 1), findDay()"
              ><img
                src="@/assets/left.png"
                style="width: 10px; transform: scaleX(-1)"
                alt=""
            /></b-button>
          </div>
        </div>

        <!-- <b-button @click="ryear = ryear - 1, pull(ryear)">-</b-button>
        <b-button @click="ryear = ryear + 1, pull(ryear)">+</b-button> -->

        <b-spinner
          variant="success"
          label="Spinning"
          style="
            width: 3rem;
            height: 3rem;
            margin: auto;
            margin-top: 20px;
            margin-bottom: 20px;
          "
          v-if="spinning"
        ></b-spinner>
        <div v-for="(time, j) in matchTimes" :key="j" class="gamebg">
          <li class="list-group-item header">
            {{ j | transliterate(cookiesObject.lang) }}
          </li>
          <div v-for="game in time" :key="game.id">
            <li class="list-group-item game" style="background: #141416">
              <div class="row">
                <div class="col-1 bodyElement mr-0 pr-3" style="">
                  <div v-if="!cookiesObject.token">
                    <b-btn
                      data-toggle="modal"
                      data-target="#exampleModal"
                      style="
                        float: right;
                        background: none;
                        width: 5px;
                        height: 5px;
                        border: none;
                      "
                    >
                      <img
                        src="@/assets/favorite.svg"
                        style="
                          width: 15px;
                          margin-top: -30px;
                          margin-left: -10px;
                        "
                        alt=""
                      />
                    </b-btn>
                  </div>
                  <div v-else>
                    <b-btn
                      v-if="favsTe.some((fav) => fav.id === game.id)"
                      v-on:click="
                        removeFavorite({ value: game.id, type: match })
                      "
                      style="
                        float: right;
                        background: none;
                        width: 5px;
                        height: 5px;
                        border: none;
                      "
                    >
                      <img
                        src="@/assets/orStar.png"
                        style="
                          width: 15px;
                          margin-top: -30px;
                          margin-left: -10px;
                        "
                        alt=""
                      />
                    </b-btn>
                    <b-btn
                      v-else
                      v-on:click="
                        addToFavorites({ value: game.id, type: match })
                      "
                      style="
                        float: right;
                        background: none;
                        width: 5px;
                        height: 5px;
                        border: none;
                      "
                    >
                      <img
                        src="@/assets/favorite.svg"
                        style="
                          width: 15px;
                          margin-top: -30px;
                          margin-left: -10px;
                        "
                        alt=""
                      />
                    </b-btn>
                  </div>
                </div>
                <router-link
                  style="color: #e6e6e6"
                  class="col ml-0 pl-0"
                  id="router-link"
                  :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"
                >
                  <div class="row">
                    <div class="col-1 bodyElement">
                      <p v-if="game.matchStatus.name == 'FT'">
                        {{ game.matchStatus.name }}
                      </p>
                      <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
                      <p v-else-if="game.matchStatus.name == 'BREAK'">BR</p>
                      <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
                      <p v-else-if="game.matchStatus.name == 'NS'">
                        {{ game.matchTime.slice(11, 16) }}
                      </p>
                      <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>
                      <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>
                      <p
                        v-else-if="game.matchStatus.name == 'LIVE'"
                        style=""
                        class="pop"
                      >
                        Live {{ calculateMinutes(game.counterStartTime) }}'
                      </p>
                      <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>
                      <p v-else>{{ game.matchStatus.name }}</p>
                    </div>
                    <div
                      class="col bodyElement"
                      :style="
                        rtl
                          ? 'margin-top: -5px; text-align: left;'
                          : 'margin-top: -5px; text-align: right;'
                      "
                    >
                      {{
                        game.team1.name.slice(0, 22)
                          | transliterate(cookiesObject.lang)
                      }}
                      <img
                        :src="teamLogo + game.team1.id"
                        alt=""
                        style="width: 20px"
                      />
                    </div>
                    <div
                      class="col-2 bodyElement"
                      v-if="
                        game.matchStatus.name == 'NS' ||
                        game.matchStatus.name == 'POSTP' ||
                        game.matchStatus.name == 'CANCL' ||
                        game.matchStatus.name == 'TBA'
                      "
                      style="letter-spacing: 3px"
                    >
                      -
                    </div>
                    <div
                      class="col-2 bodyElement"
                      style="letter-spacing: 3px"
                      v-else
                    >
                      {{
                        game.currentScore | transliterate(cookiesObject.lang)
                      }}
                    </div>
                    <div
                      class="col bodyElement"
                      :style="
                        rtl
                          ? 'margin-top: -5px; text-align: right;'
                          : 'margin-top: -5px; text-align: left;'
                      "
                    >
                      <img
                        :src="teamLogo + game.team2.id"
                        alt=""
                        style="width: 20px"
                      />
                      {{
                        game.team2.name.slice(0, 22)
                          | transliterate(cookiesObject.lang)
                      }}
                    </div>
                  </div>
                </router-link>
                <div class="col-2 ml-0 pl-5 bodyElement" style="">
                  <div>
                    <span
                      v-if="
                        game.betEnabled == 1 && game.predictionValue != null
                      "
                      style="
                        border: 1px solid #444548;
                        background: #27292c;
                        border-radius: 2px;
                        padding: 3px;
                        letter-spacing: 2px;
                        color: #e6e6e6;
                      "
                    >
                      {{
                        game.predictionValue | transliterate(cookiesObject.lang)
                      }}
                    </span>
                    <span
                      v-else-if="
                        game.betEnabled == 1 &&
                        game.predictionValue == null &&
                        game.matchStatus.name == 'NS'
                      "
                    >
                      <router-link
                        style="color: #e6e6e6; text-decoration: none"
                        class=""
                        id=""
                        :to="{
                          name: 'MatchPagePar',
                          params: { gameId: game.id, index: 3 },
                        }"
                      >
                        <img
                          style="width: 24px; margin-top: -8px"
                          src="@/assets/scoreboard.svg"
                        />
                      </router-link>
                    </span>
                    <span v-else style=""></span>
                  </div>
                </div>
              </div>
            </li>
          </div>
        </div>
      </ul>
      <ul class="list-group MobileShow pr-0 pl-0">
        <div
          class="container"
          style="background: #141416; margin-top: 0px; padding-bottom: 0px"
          v-if="ryear != 0"
        >
          <div class="row" style="padding-bottom: 0px">
            <b-form-select
              v-model="syear"
              @change="filter(syear)"
              class="mb-3 col mr-1"
              style="
                margin-top: 10px;
                background: #212225;
                border: none;
                border-radius: 2px;
                color: #e6e6e6;
                margin-bottom: 0px;
              "
            >
              <b-form-select-option
                v-for="i in seasons"
                :key="i.id"
                :value="i.id"
                >{{
                  i.name | transliterate(cookiesObject.lang)
                }}</b-form-select-option
              >
            </b-form-select>

            <b-form-select
              v-model="ryear"
              @change="pull(ryear)"
              class="mb-4 col ml-1"
              style="
                margin-top: 10px;
                background: #212225;
                border: none;
                border-radius: 2px;
                color: #e6e6e6;
                margin-bottom: 0px;
              "
            >
              <b-form-select-option
                v-for="i in rounds"
                :key="i.id"
                :value="i.id"
              >
                {{ "week" | transliterate(cookiesObject.lang) }}
                {{ i.name | transliterate(cookiesObject.lang) }} (
                <span v-if="i.start">{{
                  i.start.split("-")[2] | transliterate(cookiesObject.lang)
                }}</span>
                -
                <span v-if="i.end">{{
                  i.end.split("-")[2] | transliterate(cookiesObject.lang)
                }}</span>
                <span v-if="i.end">{{
                  monthNames[parseInt(i.end.split("-")[1] - 1)]
                    | transliterate(cookiesObject.lang)
                }}</span>
                )</b-form-select-option
              >
            </b-form-select>
          </div>
        </div>

        <div
          class="container"
          style="background: #141416; margin-top: -17px; padding-bottom: 15px"
          v-if="ryear != 0"
        >
          <div class="row">
            <div class="col"></div>
            <div class="col">
              <div class="row">
                <b-button
                  style="background: #212225; border: none; height: 30px"
                  class="col mr-1 ml-1"
                  @click="(ryear = ryear - 1), pull(ryear)"
                  ><img
                    src="@/assets/left.png"
                    style="width: 10px; margin-bottom: 8px"
                    alt=""
                /></b-button>
                <b-button
                  style="background: #212225; border: none; height: 30px"
                  class="col ml-1 mr-1"
                  @click="(ryear = ryear + 1), pull(ryear)"
                  ><img
                    src="@/assets/left.png"
                    style="
                      width: 10px;
                      margin-bottom: 8px;
                      transform: scaleX(-1);
                    "
                    alt=""
                /></b-button>
              </div>
            </div>
          </div>
        </div>

        <b-spinner
          variant="success"
          label="Spinning"
          style="
            width: 3rem;
            height: 3rem;
            margin: auto;
            margin-top: 20px;
            margin-bottom: 20px;
          "
          v-if="spinning"
        ></b-spinner>
        <div v-for="(time, j) in matchTimes" :key="j">
          <li class="list-group-item header">{{ j }}</li>
          <div v-for="game in time" :key="game.id">
            <li class="list-group-item game" style="background: #141416">
              <div class="row">
                <router-link
                  class="col"
                  id="router-link"
                  style="color: #e6e6e6"
                  :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"
                >
                  <div class="row">
                    <div
                      class="col-1 bodyElement"
                      style="margin-top: 15px; margin-right: 5px"
                    >
                      <p v-if="game.matchStatus.name == 'FT'">
                        {{ game.matchStatus.name }}
                      </p>
                      <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
                      <p v-else-if="game.matchStatus.name == 'BREAK'">BR</p>
                      <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
                      <p v-else-if="game.matchStatus.name == 'NS'">
                        {{ game.matchTime.slice(11, 16) }}
                      </p>
                      <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>
                      <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>
                      <p
                        v-else-if="game.matchStatus.name == 'LIVE'"
                        class="pop"
                      >
                        {{ calculateMinutes(game.counterStartTime) }}'
                      </p>
                      <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>
                      <p v-else>{{ game.matchStatus.name }}</p>
                    </div>
                    <div
                      class="col"
                      style="text-align: left; font-size: 11px; margin-top: 4px"
                    >
                      <div class="bodyElement" style="margin-bottom: 10px">
                        <img
                          :src="teamLogo + game.team1.id"
                          alt=""
                          style="width: 12px; margin-right: 4px"
                        />{{
                          game.team1.name.slice(0, 20)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                      <div class="bodyElement">
                        <img
                          :src="teamLogo + game.team2.id"
                          alt=""
                          style="width: 12px; margin-right: 4px"
                        />{{
                          game.team2.name.slice(0, 20)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                    </div>
                    <div class="col-2 bodyElement" style="">
                      <div>
                        <div
                          v-if="
                            game.betEnabled == 1 && game.predictionValue != null
                          "
                          style="
                            border: 1px solid #444548;
                            background: #27292c;
                            border-radius: 2px;
                            padding: 5px;
                            letter-spacing: 2px;
                            color: #e6e6e6;
                            margin-top: 8px;
                          "
                        >
                          {{ game.predictionValue }}
                        </div>
                        <span
                          v-else-if="
                            game.betEnabled == 1 &&
                            game.predictionValue == null &&
                            game.matchStatus.name == 'NS'
                          "
                        >
                          <router-link
                            style="color: #e6e6e6; text-decoration: none"
                            class=""
                            id=""
                            :to="{
                              name: 'MatchPagePar',
                              params: { gameId: game.id, index: 3 },
                            }"
                          >
                            <img
                              style="width: 24px; margin-top: 5px"
                              src="@/assets/scoreboard.svg"
                            />
                          </router-link>
                        </span>
                        <span v-else style=""></span>
                      </div>
                    </div>
                    <div
                      class="col-1"
                      v-if="game.matchStatus.name == 'NS'"
                      style="font-weight: 400; margin-top: 4px"
                    >
                      <div style="margin-bottom: 15px">?</div>
                      <div>?</div>
                    </div>
                    <div class="col-1" v-else style="margin-top: 4px">
                      <div style="margin-bottom: 15px">
                        {{
                          game.currentScore.slice(0, 1)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                      <div>
                        {{
                          game.currentScore.slice(2, 3)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                    </div>
                  </div>
                </router-link>
                <div class="col-1 bodyElement" style="margin-top: 4px">
                  <div>
                    <img
                      v-if="favsTe.some((fav) => fav.id === game.id)"
                      v-on:click="
                        removeFavorite({ value: game.id, type: match })
                      "
                      src="@/assets/orStar.png"
                      style="width: 16px; margin-top: 5px"
                      alt=""
                    />
                    <img
                      v-else
                      v-on:click="
                        addToFavorites({ value: game.id, type: match })
                      "
                      src="@/assets/favorite.svg"
                      style="width: 16px; margin-top: 5px"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </li>
          </div>
        </div>
      </ul>
    </div>
    <!-- <div style="padding-top: 10px; padding-bottom: 10px; text-align: center; background: #141416;">
        <b-btn variant="success" style="width: 200px; border-radius: 0px; background: #1c5e20;" v-on:click="pageCount++, addGames()">{{ $t('LanguageEn.moreGames') }}</b-btn>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LeaguePageGames",
  data() {
    return {
      games: [],
      gameId: "11886023",
      leagueId: "",
      spinning: "",
      matchTimes: [],
      pageCount: 1,
      match: "match",
      cookiesObject: "",
      tournament: "tournament",
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      tournamentLogo: "https://sportapi.zuniac.com/tournament/logo/",
      seasons: [],
      syear: "",
      rounds: [],
      ryear: "",
      test1: "",
      day: "",
    };
  },
  async created() {
    this.leagueId = this.$route.params.leagueId;

    this.spinning = true;

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    var offset = new Date().getTimezoneOffset();

    var seasonsc = await fetch(
      this.httpReq +
        "/tournament/" +
        this.leagueId +
        "/seasons?token=" +
        cookiesObject.token
    );
    var seasons = await seasonsc.json();
    this.seasons = seasons.seasons.reverse();
    this.syear = this.seasons[0].id;

    var roundsc = await fetch(
      this.httpReq +
        "/season/" +
        this.syear +
        "/rounds?token=" +
        cookiesObject.token
    );
    var rounds = await roundsc.json();
    this.rounds = rounds.rounds;

    this.test1 = this.rounds.filter(
      (one) =>
        Math.abs((new Date() - new Date(one.start)) / (1000 * 60 * 60 * 24)) < 7
    );

    if (this.test1.length > 0) {
      this.ryear = this.test1[0].id;
      this.day = this.test1[0].name;
    } else {
      if (this.rounds[0]) {
        this.ryear = this.rounds[0].id;
      } else {
        this.ryear = 0;
      }
    }

    if (cookiesObject.token && this.ryear != 0) {
      var res = await fetch(
        this.httpReq +
          "/round/matches?roundId=" +
          this.ryear +
          "&timezone=%2B04%3A00&token=" +
          cookiesObject.token
      );
      var data = await res.json();
      this.games = data.matches;

      if (data.code == 200) {
        //everything is okay
      } else if (data.code == 401) {
        alert("Not Authorized, need to re sign in!");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      } else if (data.code == 404) {
        alert("Token is not valid and portal id not provided");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      } else if (data.code == 500) {
        alert("Oops, something went wrong!");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      } else {
        alert("service error");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      }
    } else {
      var resp = await fetch(
        this.httpReq +
          "/tournament/matches?langId=" +
          this.cookiesObject.langId +
          "&page=1&portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&timezone=%2B" +
          offset / -60 +
          "%3A00&tournamentId=" +
          this.leagueId
      );
      var datas = await resp.json();
      this.games = datas.matches;
    }

    const times = {};
    this.games.forEach((e) => {
      const date = e.matchTime.split(" ")[0];

      if (typeof times[date] === "undefined") {
        times[date] = [];
      }

      times[date].push(e);
    });

    this.matchTimes = times;

    this.spinning = false;

    this.findDay();

    this.$forceUpdate();
  },
  methods: {
    ...mapActions(["removeFavorite", "addToFavorites"]),
    getDate() {
      var dateObj = new Date();
      var month = dateObj.getUTCMonth() + 1;
      var monthd = "0" + month;
      var day = dateObj.getUTCDate();
      var year = dateObj.getUTCFullYear();

      var newdate = year + "-" + monthd + "-" + day;

      return newdate;
    },
    addGames() {
      fetch(
        this.httpReq +
          "/tournament/matches?page=" +
          this.pageCount +
          "&portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&timezone=%2B04%3A00&tournamentId=" +
          this.leagueId
      )
        .then((res) => res.json())
        .then((data) => {
          const times = this.matchTimes;
          data.matches.forEach((e) => {
            const date = e.matchTime.split(" ")[0];

            if (typeof times[date] === "undefined") {
              times[date] = [];
            }

            times[date].push(e);
          });
          this.matchTimes = times;
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    calculateMinutes(value) {
      if (value == null) {
        return "LIVE";
      } else {
        var startDate = new Date(value.replace(" ", "T"));
        var endDate = Date.now();
        var difference = (endDate - startDate) / 1000 / 60;

        if (difference < 0) {
          difference = difference + 240;
        }

        return parseInt(difference);
      }
    },
    async filter(val) {
      var roundsc = await fetch(
        this.httpReq +
          "/season/" +
          val +
          "/rounds?token=" +
          this.cookiesObject.token
      );
      var rounds = await roundsc.json();
      this.rounds = rounds.rounds;
      this.ryear = rounds.rounds[0].id;
    },

    async pull(val) {
      var res = await fetch(
        this.httpReq +
          "/round/matches?roundId=" +
          val +
          "&timezone=%2B04%3A00&token=" +
          this.cookiesObject.token
      );
      var data = await res.json();
      this.games = data.matches;

      const times = {};
      this.games.forEach((e) => {
        const date = e.matchTime.split(" ")[0];

        if (typeof times[date] === "undefined") {
          times[date] = [];
        }

        times[date].push(e);
      });

      this.matchTimes = times;
    },
    async findDay() {
      var tempArr = this.rounds.filter((one) => one.name == this.day);
      this.ryear = tempArr[0].id;
      this.pull(tempArr[0].id);
    },
  },
  components: {},
  props: {},
  computed: {
    ...mapGetters(["favsTe", "favsT", "httpReq", "rtl"]),
    monthNames() {
      return [
        this.$t("LanguageEn.month1"),
        this.$t("LanguageEn.month2"),
        this.$t("LanguageEn.month3"),
        this.$t("LanguageEn.month4"),
        this.$t("LanguageEn.month5"),
        this.$t("LanguageEn.month6"),
        this.$t("LanguageEn.month7"),
        this.$t("LanguageEn.month8"),
        this.$t("LanguageEn.month9"),
        this.$t("LanguageEn.month10"),
        this.$t("LanguageEn.month11"),
        this.$t("LanguageEn.month12"),
      ];
    },
  },
};
</script>

<style scoped>
#router-link {
  color: black;
  text-decoration: none;
}

.container {
  margin-top: 12px;
}

li {
  line-height: 5px;
  border-radius: 0px !important;
  font-size: 12px;
}
.LeagueName {
  margin-bottom: 10px;
}

.header {
  background: #212225;
  color: lightgrey;
}

.bodyElement {
  padding: 0;
  height: 8px;
}

.game {
  text-align: center;
  background: #141416;
}
.gamebg :hover {
  background: #27292c !important;
}

@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
<style>
.custom-select {
  background: #212225
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='grey' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px !important;
}
</style>